import * as React from 'react';
import { getBasePath } from '../../utils/browser';
import IconImage, { IconImageColorFilterProps } from './IconImage';

interface ToolIconProps {
  readonly iconName?: string;
  readonly text?: string;
  readonly style?: React.CSSProperties;
  readonly svgStyle?: React.CSSProperties;
  readonly imageStyle?: React.CSSProperties;
  readonly title?: string;
  readonly ariaLabel?: string;
  readonly margin?: boolean;
  readonly colorFilter?: IconImageColorFilterProps;
}

const textStyle: React.CSSProperties = {
  maxWidth: '48px',
  maxHeight: '48px',
  pointerEvents: 'none',
  textDecoration: 'none',
  color: 'white',
  fontSize: '11px',
  padding: '4px',
};

const buttonStyle: React.CSSProperties = {
  minWidth: '48px',
  height: '48px',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  justifyContent: 'center',
  color: 'inherit',
  textDecoration: 'none',
  backgroundColor: 'rgba(0, 0, 0, 0.1)',
  boxSizing: 'border-box',
  overflow: 'hidden',
};

const ToolIcon: React.SFC<ToolIconProps> = React.memo((props) => {
  const {
    iconName, text, style, svgStyle, imageStyle, title, ariaLabel, margin, colorFilter, children,
  } = props;

  const baseDir = getBasePath();
  const imgSrc = iconName != null ? `${baseDir}/images/tool-icons/${iconName}.png` : null;

  const buttonAdditionalStyle: React.CSSProperties = {};
  if (margin !== false) {
    buttonAdditionalStyle.margin = '8px';
  }

  return (
    <div
      style={{
        ...buttonStyle,
        ...buttonAdditionalStyle,
        ...style,
      }}
      title={title}
      aria-label={ariaLabel} >
      {text != null
        ? <div style={{ ...textStyle }}>{text}</div>
        : null}
      {imgSrc != null
        ? <IconImage src={imgSrc} style={imageStyle} svgStyle={svgStyle} { ...colorFilter } />
        : null}
      {children}
    </div>
  );
});

export default ToolIcon;
